import { type CookieAttributes } from 'js-cookie';

export interface DurationCookieTypes {
	session?: boolean;
	persistent?: boolean;
}

export interface PurposeCookieTypes {
	necessary?: boolean;
	preferences?: boolean;
	statistics?: boolean;
	marketing?: boolean;
}

export interface ProvenanceCookieTypes {
	firstParty?: boolean;
	thirdParty?: boolean;
}

type CookieTypes = PurposeCookieTypes & DurationCookieTypes & ProvenanceCookieTypes;

export type AllCookieTypeKeys = keyof CookieTypes;

export type CookieDurationType = keyof DurationCookieTypes;
export type CookiePurposeType = keyof PurposeCookieTypes;
export type CookieProvenanceType = keyof ProvenanceCookieTypes;

// Other Types

export interface SetCookieProps {
	purpose: CookiePurposeType;
	duration: CookieDurationType;
	provenance: CookieProvenanceType;
}

export interface CookieWrapper {
	set: <T extends object = object>(name: string, value: string | T, props: SetCookieProps, options?: Cookies.CookieAttributes) => string | undefined;
	get: (name: string) => string | undefined;
	getAll: () => Record<string, string>;
	remove: (name: string, options?: CookieAttributes) => void;
}

export type DidDeclineAllHandler = (opts?: { includingNecessary: boolean }) => boolean;

export interface ConsentHookActions {
	acceptCookies: (cookies: CookieTypes, options?: AcceptCookiesOptions) => void;
	declineAllCookies: () => void;
	acceptAllCookies: () => void;
	didAcceptAll: () => boolean;
	didDeclineAll: DidDeclineAllHandler;
}

export type ConsentState = CookieTypes;

export type CookieConsentHookParams = {
	defaultConsent?: ConsentState;
	consentCookieAttributes?: CookieAttributes;
};

export interface AcceptCookiesOptions {
	allowChangingNecessary?: boolean;
}

export const COOKIE_CONSENT_KEY = 'cc_cookie_v4';
export const DEFAULT_CONSENT: ConsentState = { necessary: true };
